export const NAME = 'ebonReminder';

export const REQUEST_EBONS_REMINDER = 'REQUEST_EBONS_REMINDER';
export const SUCCESS_EBONS_REMINDER = 'SUCCESS_EBONS_REMINDER';
export const FAILURE_EBONS_REMINDER = 'FAILURE_EBONS_REMINDER';

export const RESET_FORM_SUBMIT_SEND_EBON_REMINDER = 'RESET_FORM_SUBMIT_SEND_EBON_REMINDER';



// WEBPACK FOOTER //
// ./src/services/ebonReminder/constants.js